import React, { createContext } from 'react'
import { AcademyHookReturns } from '../../Hooks/academy/academy.types'
import { usePlayData } from '../../Hooks/academy/usePlayData'

export type AcademyContextType = AcademyHookReturns

export const AcademyContext = createContext<AcademyContextType | null>(null)

export const AcademyProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const academyContextValues = usePlayData()

  return (
    <AcademyContext.Provider value={academyContextValues}>
      {children}
    </AcademyContext.Provider>
  )
}
